import type { FC } from "react";
import { renderShortAbsoluteTimestamp } from "./helpers.js";
import { smallTimestampStyle } from "./styles.js";
import { useNow } from "./timestampContext.js";

interface ShortAbsoluteTimestampProps {
  timestamp: string;
}

/** Shows a timestamp with small font size based on how long ago it is. If today, only show the time. If less than a year ago, show the month/day. Otherwise, show month/day/year. */
export const ShortAbsoluteTimestamp: FC<ShortAbsoluteTimestampProps> = (
  props,
) => {
  const now = useNow();

  return (
    <time className={smallTimestampStyle()} dateTime={props.timestamp}>
      {renderShortAbsoluteTimestamp(now, props.timestamp)}
    </time>
  );
};
